/* Saiguen — micro-animaciones de peso cero + videos de la franja "Tu intención, de cerca".
 * - Reveal on scroll (.sg-reveal -> .sg-in) con stagger de 90 ms entre hermanos, una sola vez.
 * - Videos de [data-sg-videos]: el src se asigna recién cuando el tile está >= 50 % visible; pause al salir.
 * - Videos autoplay de bloques (snippets/video.liquid): llegan en <template data-sg-autoplay-video> y se montan al acercarse al viewport.
 * - prefers-reduced-motion: reduce => sin reveal ni videos de la franja (el CSS deja todo visible y estático). */
(function () {
  'use strict';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var STAGGER = 90;

  /* ---------- Reveal on scroll ---------- */
  var revealObserver = null;

  function leafGroups(section) {
    var groups = section.querySelectorAll('.group-block');
    var out = [];
    for (var i = 0; i < groups.length; i++) {
      if (!groups[i].querySelector('.group-block')) out.push(groups[i]);
    }
    return out;
  }

  var EXCLUDE = '.hero-wrapper, [id$="__hero_main"], #header-group, #footer-group, .header-section, .footer-section, .announcement-bar';

  function collectTargets(root) {
    var targets = [];
    var push = function (el) { if (el && targets.indexOf(el) === -1) targets.push(el); };
    var scope = (root && root.querySelectorAll) ? root : document;
    var sectionKeys = ['intenciones_cols', 'pilares', 'amuletos_home', 'confianza_home', 'ritual_pasos'];
    for (var k = 0; k < sectionKeys.length; k++) {
      var secs = scope.querySelectorAll('.shopify-section[id$="__' + sectionKeys[k] + '"]');
      for (var s = 0; s < secs.length; s++) leafGroups(secs[s]).forEach(push);
    }
    // Tarjetas de producto (home, colecciones, recomendaciones)
    scope.querySelectorAll('product-card, .product-card').forEach(push);
    // Tiles y encabezado de la franja de videos
    scope.querySelectorAll('[data-sg-videos] .sg-tile, [data-sg-videos] .sg-videos__head').forEach(push);
    // Encabezados de sección: bloques de texto con h1-h3
    var heads = scope.querySelectorAll('.shopify-section .text-block');
    for (var h = 0; h < heads.length; h++) {
      if (heads[h].querySelector('h1, h2, h3')) push(heads[h]);
    }
    // Filtrar: fuera del hero/header/footer y sin ancestro ya elegido (evita doble animación)
    return targets.filter(function (el) {
      if (el.closest(EXCLUDE)) return false;
      var p = el.parentElement;
      while (p) {
        if (targets.indexOf(p) !== -1 || p.classList.contains('sg-reveal')) return false;
        p = p.parentElement;
      }
      return true;
    });
  }

  function onReveal(entries) {
    var parents = [];
    var byParent = new Map();
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var parent = entry.target.parentElement || document.body;
      if (!byParent.has(parent)) { byParent.set(parent, []); parents.push(parent); }
      byParent.get(parent).push(entry.target);
    });
    parents.forEach(function (parent) {
      var els = byParent.get(parent);
      els.sort(function (a, b) { return (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) ? -1 : 1; });
      els.forEach(function (el, i) {
        el.style.transitionDelay = (i * STAGGER) + 'ms';
        el.classList.add('sg-in');
        revealObserver.unobserve(el);
        el.addEventListener('transitionend', function clear() {
          el.style.transitionDelay = '';
          el.removeEventListener('transitionend', clear);
        });
      });
    });
  }

  function setupReveal(root) {
    var targets = collectTargets(root);
    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('sg-reveal', 'sg-in'); });
      return;
    }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(onReveal, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    }
    targets.forEach(function (el) {
      if (el.classList.contains('sg-reveal')) return;
      el.classList.add('sg-reveal');
      revealObserver.observe(el);
    });
  }

  /* ---------- Videos de la franja ---------- */
  var videoObserver = null;

  function playTile(video) {
    if (!video.getAttribute('src')) {
      var src = video.getAttribute('data-src');
      if (!src) return;
      video.setAttribute('src', src); // recién acá se descarga
      video.load();
    }
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  function onVideo(entries) {
    entries.forEach(function (entry) {
      var video = entry.target;
      if (entry.isIntersecting && entry.intersectionRatio >= 0.5) playTile(video);
      else if (!video.paused) video.pause();
    });
  }

  function setupVideos(root) {
    var scope = (root && root.querySelectorAll) ? root : document;
    var videos = scope.querySelectorAll('[data-sg-videos] video[data-src]');
    if (!videos.length || !('IntersectionObserver' in window)) return; // sin IO quedan los posters
    if (!videoObserver) videoObserver = new IntersectionObserver(onVideo, { threshold: [0, 0.5, 1] });
    videos.forEach(function (v) {
      if (v.__sgObserved) return;
      v.__sgObserved = true;
      v.muted = true; v.loop = true; v.playsInline = true;
      videoObserver.observe(v);
    });
  }

  // En desktop Horizon scrollea dentro de .page-wrapper (no window) y ahí el rootMargin de los IO no tiene efecto.
  // Se consulta recién después de load: medirlo antes (getComputedStyle + scrollHeight) forzaba un layout que atrasaba el primer pintado.
  function pageWrapperScrolls() {
    var pw = document.querySelector('.page-wrapper');
    if (!pw) return false;
    var oy = getComputedStyle(pw).overflowY;
    return (oy === 'auto' || oy === 'scroll') && pw.scrollHeight > pw.clientHeight + 1;
  }

  /* ---------- Videos autoplay de bloques (snippets/video.liquid) ---------- */
  var autoplayObserver = null;

  function mountAutoplay(tpl) {
    var frag = tpl.content.cloneNode(true);
    var video = frag.querySelector('video');
    tpl.replaceWith(frag);
    if (video) {
      video.muted = true;
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }
  }

  function setupAutoplayVideos() {
    var tpls = document.querySelectorAll('template[data-sg-autoplay-video]');
    if (!tpls.length) return;
    if (!('IntersectionObserver' in window)) { tpls.forEach(mountAutoplay); return; }
    if (!autoplayObserver) {
      autoplayObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          autoplayObserver.unobserve(en.target);
          en.target.querySelectorAll('template[data-sg-autoplay-video]').forEach(mountAutoplay);
        });
      }, { rootMargin: '150px 0px' });
    }
    tpls.forEach(function (t) {
      var host = t.parentElement; // <deferred-media>: el <template> no tiene caja propia
      if (!host || host.__sgAutoplay) return;
      host.__sgAutoplay = true;
      autoplayObserver.observe(host);
    });
  }

  /* ---------- Pósters diferidos de la franja (el atributo poster de <video> nunca es lazy) ---------- */
  var posterObserver = null;

  function setupPosters() {
    var vids = document.querySelectorAll('video[data-poster]');
    if (!vids.length) return;
    var assign = function (v) { v.setAttribute('poster', v.getAttribute('data-poster')); v.removeAttribute('data-poster'); };
    if (!('IntersectionObserver' in window)) { vids.forEach(assign); return; }
    if (!posterObserver) {
      posterObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          posterObserver.unobserve(en.target);
          en.target.querySelectorAll('video[data-poster]').forEach(assign);
        });
      }, { rootMargin: '600px 0px' }); // listos antes de que la franja entre en pantalla
    }
    vids.forEach(function (v) {
      // Se observa el contenedor de la franja (en mobile los tiles están recortados por el carrusel horizontal)
      var box = v.closest('[data-sg-videos]') || v;
      if (box.__sgPoster) return;
      box.__sgPoster = true;
      posterObserver.observe(box);
    });
  }

  /* ---------- Init ---------- */
  function init(root) {
    setupPosters();
    setupAutoplayVideos(); // también con reduced-motion: el video autoplay original tampoco lo respetaba
    if (reduced) return;
    setupReveal(root);
    setupVideos(root);
  }

  function afterLoad() {
    var idle = window.requestIdleCallback || function (fn) { setTimeout(fn, 200); };
    idle(function () {
      // Desktop: sin rootMargin efectivo, los pósters de la franja se asignan acá (ya pasó la carga) para que nunca se vea un tile vacío
      if (pageWrapperScrolls()) {
        document.querySelectorAll('video[data-poster]').forEach(function (v) {
          v.setAttribute('poster', v.getAttribute('data-poster'));
          v.removeAttribute('data-poster');
        });
      }
    }, { timeout: 2000 });
  }
  if (document.readyState === 'complete') afterLoad();
  else window.addEventListener('load', afterLoad, { once: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target || document); });

  // Contenido que llega por AJAX (filtros de colección, recomendaciones)
  if (!reduced && window.MutationObserver) {
    var pending = null;
    // Solo re-inicializa si llegó contenido que nos importa (tarjetas, secciones, videos); ignora lo que inyectan
    // los scripts de Shopify y nuestros propios nodos (videos montados), que disparaban init() completo de más.
    var RELEVANT = 'product-card, .product-card, .shopify-section, [data-sg-videos], template[data-sg-autoplay-video], video[data-poster]';
    var relevant = function (n) {
      return n.nodeType === 1 && (n.matches(RELEVANT) || !!n.querySelector(RELEVANT));
    };
    new MutationObserver(function (records) {
      if (pending) return;
      var hit = records.some(function (r) { return Array.prototype.some.call(r.addedNodes, relevant); });
      if (!hit) return;
      pending = setTimeout(function () { pending = null; init(document); }, 150);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
